import { render, staticRenderFns } from "./ProcessFileInfo.vue?vue&type=template&id=50906000&"
import script from "./ProcessFileInfo.vue?vue&type=script&lang=js&"
export * from "./ProcessFileInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports